
import { Col, Row, Button } from 'react-bootstrap';
import React, { Component } from 'react';
import { Toast, Position } from 'devextreme-react/toast';
import '../../css/utils/toastrcustom.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
class ToastrCustom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            message: null
        };
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.setType = this.setType.bind(this);
        this.setMessage = this.setMessage.bind(this);
        this.contentRender = this.contentRender.bind(this);
        this.getId = this.getId.bind(this);
    }

    setType(type) {
        this.setState({
            type: type
        });
    };

    setMessage(message) {
        this.setState({
            message: message
        });
    };

    show() {
        this.setState({
            isVisible: true
        });
    };

    hide(e) {

        this.setState({
            isVisible: false
        });
    };
    getId() {
        return this.state.message.id;
    }

    contentRender() {
        let channel = this.state.message.channel;
        let date = new Date(this.state.message.date);
        if (!channel)
            channel = "internal";
        let className = "icon-notification " + channel.toLowerCase(),
            text = this.state.message.text;
        if (text != null && text.length > 15)
            text = text.substr(0, 15) + "...";

        return (<>
            <Button variant='primary' size='sm' className='notification-close' onClick={this.hide}><FontAwesomeIcon icon={solid('xmark')} /></Button>
            <div className='notification' onClick={this.props.select}>
                <Row>
                    <Col lg="3"><div className={className}></div>
                    </Col>
                    <Col lg="9">
                        <div className='notification-name'>{this.state.message.name}</div>
                        <div className='notification-text'>{text}</div>
                        <div className='notification-info'>{this.state.message.channel} {date.toLocaleTimeString()}</div>

                    </Col>
                </Row>
            </div></>

        )
    }

    render() {
        return (

            <Toast
                visible={this.state.isVisible}
                type="custom"
                onHiding={this.hide}
                height={90}
                width={260}
                displayTime={100000}
                contentRender={this.contentRender}
            >
                <Position
                    my="top right"
                    at="top right"
                    offset={"0 80"}
                />
            </Toast>

        );
    };
}


export default ToastrCustom;
